module.exports = __webpack_public_path__ + "static/media/碩_入學考試_選考科目建議閱讀書單.450467ca.pdf";